<template>
    <div>
        <div class="filter-grid" :class="narrow ? 'filter-grid-narrow' : null">
            <div class="filter-grid-full">
                <CarCategorySelect v-model="filter.category"/>
            </div>
            <div class="filter-grid-full">
                <TireTypeSelect v-model="filter.tire_types"/>
            </div>
            <div v-if="!customer">
                <CustomerTypeSelect v-model="filter.customer_is_company"/>
            </div>
            <div>
                <v-text-field label="Lokasjon" v-mask="locationMask" placeholder="H0-00-00" v-model="filter.location"
                              return-masked-value/>
            </div>
            <div>
                <LeasingSelect v-model="filter.is_leasing"/>
            </div>
            <div v-if="!customer">
                <customer-category-select v-model="filter.customer_category"/>
            </div>
            <div>
                <v-select :items="newTireItems" v-model="filter.tires_state" label="Nytt dekk?" hide-details/>
            </div>
            <div>
                <v-select :items="allYesNoItems" v-model="filter.has_third_party" label="Fakturert?" hide-details/>
            </div>
            <div>
                <v-select :items="allYesNoItems" v-model="filter.tires_has_sensor" label="Har sensor?" hide-details/>
            </div>
            <div>
                <v-select :items="allYesNoItems" v-model="filter.tires_is_sensor_working" label="Sensor OK?"
                          v-if="filter.tires_has_sensor" hide-details/>
            </div>
            <div>
                <InvoiceYearSelect v-model="filter.invoice_year"></InvoiceYearSelect>
            </div>
            <div class="hidden-print-only">
                <v-btn color="deep-orange" outlined class="ma-0 px-2" @click="filter.is_deleted = true"
                       v-if="!filter.is_deleted">
                    Vis arkiv
                </v-btn>
                <v-btn color="primary" outlined class="ma-0 px-2" @click="filter.is_deleted = false"
                       v-if="filter.is_deleted">
                    Vis aktive
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import {debounce} from 'lodash';
import {cleanFilter} from "../../../helpers";
import CarCategorySelect from '../CarCategorySelect';
import CustomerCategorySelect from '../CustomerCategorySelect';
import TireTypeSelect from "@/components/helpers/filter/TireTypeSelect";
import CustomerTypeSelect from "@/components/helpers/filter/CustomerTypeSelect";
import LeasingSelect from "@/components/helpers/filter/LeasingSelect";
import InvoiceYearSelect from "@/components/helpers/filter/InvoiceYearSelect";
import * as moment from "moment";

export default {
    props: {
        narrow: {
            type: Boolean,
            default: false
        },
        customer: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CarCategorySelect,
        TireTypeSelect,
        CustomerCategorySelect,
        CustomerTypeSelect,
        LeasingSelect,
        InvoiceYearSelect
    },
    data() {
        return {
            filter: {
                is_deleted: false,
                category: null,
                customer_is_company: null,
                is_leasing: null,
                customer_category: null,
                has_third_party: null,
                tire_types: null,
                tires_state: null,
                tires_has_sensor: null,
                tires_is_sensor_working: null,
                invoice_year: moment().year(),
                ...cleanFilter(this.$route.query),
                page: 1,
            }
        }
    },
    created() {
        this.tireTypesCheck();
    },

    watch: {
        filter: {
            handler: debounce(function () {
                if (this.filter.tires_has_sensor !== true && this.filter.tires_is_sensor_working !== null) {
                    this.filter.tires_is_sensor_working = null;
                }

                this.$router.replace({query: cleanFilter(this.filter)});
                this.$emit('filter', {...this.filter});
            }, 500),
            deep: true,
        }
    },

    computed: {
        newTireItems() {
            return [
                {value: null, text: 'Alle'},
                {value: 'recommended', text: 'Bør ha nytt'},
                {value: 'confirmed', text: 'Avtalt nytt'},
                {value: 'new', text: 'Satt på nytt'}
            ]
        },

        allYesNoItems() {
            return [
                {value: null, text: 'Alle'},
                {value: true, text: 'Ja'},
                {value: false, text: 'Nei'},
            ]
        },
        locationMask() {
            return this.$root.settings.location_mask || 'A#-##-##-#';
        }
    },
    methods:{
        tireTypesCheck(){
            if (this.filter.tire_types != null && !Array.isArray(this.filter.tire_types)){
                let tire_types_string = this.filter.tire_types;
                this.filter.tire_types = [];
                this.filter.tire_types.push(tire_types_string);
            }
        }
    },
}
</script>

<style>
.filter-grid {
    min-width: 60vw;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 120px 320px repeat(auto-fill, minmax(auto, 120px));
    justify-content: space-between;
}

.filter-grid-narrow {
    min-width: auto;
    display: flex;
    flex-wrap: wrap;
}

.filter-grid-narrow > div {
    flex-basis: 48%;
    flex-basis: calc(50% - 0.5rem);
    margin: 0.5rem 0;
}

.filter-grid-narrow .filter-grid-full {
    flex-basis: 100%;
}

@media print {
    .filter-grid-narrow > div, .filter-grid-narrow .filter-grid-full {
        flex-basis: 0;
        flex-grow: 1;
        padding-right: 0.5cm
    }

    .filter-container .affix {
        position: static !important;
    }
}
</style>
